import { INDEX_PATH } from "../../config/constants/Constants";

export function scrollToTop(element = window) {
    if (!element) return;
    element.scrollTo({
        top: 0,
        behavior: "smooth",
    });
}

export const getKeyFromQuery = (key, url) => {
    const currentURL = url || window.location.href;
    const urlObject = new URL(currentURL.replace("#/", ""));
    return urlObject.searchParams.get(key);
};

export const getPathFromUrl = (url) => {
    const currentURL = url || window.location.href;
    const urlObject = new URL(currentURL.replace("#/", "").replace(INDEX_PATH, ""));
    return urlObject.pathname;
};
